import styled from 'styled-components';
import {
  boxModelStyles,
  colorStyles,
  fontStyles,
  IBoxModelStyleProps,
  IColorStyleProps,
  IFontStyleProps
} from '../../styles/css';

/* eslint-disable-next-line prettier/prettier */
export interface IStyledTextProps extends IBoxModelStyleProps, IColorStyleProps, IFontStyleProps {
  $cursor?: string;
}

const StyledText = styled.span<IStyledTextProps>`
  ${({ $cursor }) => ($cursor ? `cursor: ${$cursor};` : '')}
  ${boxModelStyles}
  ${fontStyles}
  ${colorStyles}
`;

export default StyledText;
